export var ifOverflowMatches = function ifOverflowMatches(props, value) {
  var alwaysShow = props.alwaysShow;
  var ifOverflow = props.ifOverflow;
  if (alwaysShow) {
    ifOverflow = 'extendDomain';
  }
  return ifOverflow === value;
};


//////////////////
// WEBPACK FOOTER
// ./~/recharts/es6/util/IfOverflowMatches.js
// module id = ./node_modules/recharts/es6/util/IfOverflowMatches.js
// module chunks = 1